export const PAGINATION_CURRENT_PAGE = 0;
export const PAGINATION_START = 0;
export const PAGINATION_LIMIT = 50;

export const COLUMNS = [
  {
    field: "client.name",
    header: "Client",
    resizeable: true,
    alignHeader: 'center',
    align: 'left',
    sortable: true,
    frozen: true,
  },
  {
    field: "billingType",
    header: "Facturation actuelle",
    alignHeader: 'center',
    sortable: true,
  },
  {
    field: "proposedPlan",
    header: "Forfait Proposé",
    alignHeader: 'center',
    sortable: true,
  },
  {
    field: "plannedRdv",
    header: "Prise de Rendez-vous",
    alignHeader: 'center',
    align: 'left',
  },
  {
    field: "lmSigned",
    header: "LDM signée",
    alignHeader: 'center',
    style: {
      width: '240px'
    }
  },
  {
    field: "signingMethod",
    header: "Mode de signature",
    alignHeader: 'center',
  },
  {
    field: "bankDomiciliation",
    header: "Domiciliation bancaire",
    alignHeader: 'center',
  },
  {
    field: "updates",
    header: "Mise à jour",
    alignHeader: "center"
  },
  {
    field: "notes",
    header: "Notes",
    alignHeader: "center"
  }
];

export const PROPOSED_PLAN_STATUS_OPTIONS = [
  {
    value: "ACCEPTED",
    label: "Accord"
  },
  {
    value: "PENDING",
    label: "En attente"
  },
  {
    value: "REJECTED",
    label: "Refus"
  },
];

export const SIGNING_METHOD_OPTIONS = [
  {
    value: "PAPER",
    label: "Papier"
  },
  {
    value: "DIGITAL",
    label: "Électronique"
  }
];

export const BANK_DOMICILIATION_OPTIONS = [
  {
    value: "YES",
    label: "Oui"
  },
  { value: "NO",
    label: "Non"
  },
  { value: "PENDING",
    label: "En attente"
  }
];
